import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccidentInfoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0226 15.6211H14.8039C12.962 15.6211 12.5461 16.5511 12.3183 17.7011L11.4766 21.7511H23.3598L22.5181 17.7011C22.2705 16.5511 21.8645 15.6211 20.0226 15.6211Z",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8252 28.3622C24.9044 29.2422 24.2112 30.0022 23.32 30.0022H21.9237C21.1216 30.0022 21.0126 29.6522 20.8641 29.2322L20.7155 28.7822C20.5076 28.1722 20.369 27.7522 19.2995 27.7522H15.4968C14.4273 27.7522 14.2689 28.2222 14.0807 28.7822L13.9322 29.2322C13.7936 29.6622 13.6846 30.0022 12.8726 30.0022H11.4763C10.5851 30.0022 9.88201 29.2422 9.97113 28.3622L10.387 23.7922C10.496 22.6622 10.7039 21.7422 12.6548 21.7422H22.1316C24.0825 21.7422 24.2904 22.6622 24.3993 23.7922L24.8252 28.3622Z",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4666 19.5H10.7239",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0923 19.5H23.3496",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9519 24.75H15.18",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.636 24.75H21.8641",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6535 8.13157C26.6853 8.12884 26.7172 8.13311 26.7469 8.14407C26.7766 8.15503 26.8034 8.17242 26.8254 8.19504L27.583 8.71687C27.6492 8.75473 27.7039 8.80967 27.7418 8.87622C27.7796 8.94276 27.7992 9.01857 27.7985 9.09608C27.736 9.28809 27.6434 9.46946 27.5242 9.63322L23.0092 15.0003L26.0777 8.65221C26.2207 8.29179 26.4153 8.12205 26.6535 8.13157ZM31.3067 11.0572C31.3071 10.9153 31.2526 10.7802 31.1548 10.6805L30.4168 9.85323C30.3672 9.79231 30.3047 9.74338 30.2337 9.70987C30.1627 9.67636 30.0849 9.65909 30.0057 9.65926C29.862 9.67025 29.7227 9.71886 29.6017 9.80024C29.4807 9.88163 29.3821 9.99296 29.3158 10.1232L23.6903 16.7318L30.7851 11.762C31.1059 11.4774 31.2928 11.3074 31.3088 11.0584L31.3067 11.0572ZM31.4613 16.2449L31.2809 15.319C31.2698 15.2434 31.2372 15.1732 31.1869 15.1169C31.1366 15.0605 31.0709 15.0204 30.9976 15.0014C30.9053 14.9773 30.8083 14.9736 30.7135 14.9907C30.6186 15.0078 30.5279 15.0452 30.4478 15.1004L23.8804 17.4562L30.761 16.8205C31.3088 16.788 31.563 16.5641 31.4635 16.2461L31.4613 16.2449Z",
			fill: "#2DAB77"
		})
	]
});
export default SvgAccidentInfoIcon;
